import React from 'react';
import { Button, Form, useModal } from '@ampol/design-system';
import './rsa-terms-and-conditions-modal.scss';
import RsaTermsAndConditionsContent from './rsa-terms-and-conditions-content';

const RsaTermsAndConditionsModal = ({ vehicleTypeSelected, readOnly }) => {

  const handleOpenModal = () => {
    detailModal.open();
  };

  const getLabel = () => {
    return <div>
      I have opened and read the Roadside Assist <Button label="Terms and Conditions" variant="primary" color="blue" onClick={() => handleOpenModal()} />
    </div>;
  };

  const detailModal = useModal({
    id: 'termsAndConditions',
    title: 'Terms and Conditions',
    content: <RsaTermsAndConditionsContent vehicleTypeSelected={vehicleTypeSelected} />,
    variant: 'triple',
    color: 'blue',
    actions: [
      {
        label: 'Close',
        onClick: () => detailModal.close(),
      },
    ],
  });

  return (
    <div className="terms-and-conditions-modal">
      <Form.Checkbox
        label={getLabel()}
        name={'termsAndConditions'}
        color={'blue'}
        className={'terms-and-conditions-modal__checkbox'}
        disabled={readOnly}
      />
    </div>
  );
};

export default RsaTermsAndConditionsModal;
